import { createFileRoute } from "@tanstack/react-router";
import { TripPlannerPage } from "../../../features/discover/pages/trip-planner-page";

export const Route = createFileRoute("/$lang/_layout/trip-planner")({
  component: TripPlannerPage,
});
